<template>
  <span v-if="level == undefined"
    :class="['bg-gray-100 text-gray-400 ring-gray-600/20', cssClasses || defaultClasses]">{{ $gettext("En attente") }}</span>
  <span v-if="level === 'low'"
    :class="['bg-green-100 text-green-400 ring-green-600/20', cssClasses || defaultClasses]">{{ $gettext("Faible") }}</span>
  <span v-if="level === 'medium'"
    :class="['bg-amber-100 text-amber-400 ring-amber-600/20', cssClasses || defaultClasses]">{{ $gettext("Standard") }}</span>
  <span v-if="level === 'high'"
    :class="['bg-red-100 text-red-400 ring-red-600/20', cssClasses || defaultClasses]">{{ $gettext("Elevé") }}</span>
  <span v-if="level === 'rejected'"
    :class="['bg-black text-white ring-black-600/20', cssClasses || defaultClasses]">{{ $gettext("Refus") }}</span>
  <span v-if="level === 'blacklisted'"
    :class="['bg-black text-white ring-black-600/20', cssClasses || defaultClasses]">{{ $gettext("Liste noire") }}</span>
</template>

<script setup>
defineProps({
  level: String,
  cssClasses: String
});

const defaultClasses = "text-center justify-center ml-2 inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset w-20";
</script>
